import type Good from '@/core/model/good';
import type GoodClass from '@/core/model/good-class';
import { GOOD_CLASSES } from '@/core/model/good-class';

const dedupeGoodsByExternalId = (goods: Good[]): Good[] => {
    const uniqueGoods: Good[] = [];
    goods.forEach(good => {
        if (!uniqueGoods.some(g => g.externalId === good.externalId)) {
            uniqueGoods.push(good);
        }
    });

    return uniqueGoods;
}

export const buildProductSearchResultWithProductCart = (searchClasses:GoodClass[], selectedClasses:number[], selectedGoods:Good[]): GoodClass[] => {
    const resultClasses: GoodClass[] = [];

    //add first top two classes from currentSearch
    resultClasses.push(...searchClasses.slice(0, 2));

    //add classes from selected goods if not already in resultClasses
    selectedClasses.forEach(classNumber => {
        if (resultClasses.some(c => c.classNumber === classNumber)) {
            return;
        }

        let classToAdd = searchClasses.find(c => c.classNumber === classNumber);
        if (!classToAdd) {
            classToAdd = {
                name: '',
                id: classNumber,
                classNumber: classNumber,
                suggestions: [],
                matches: []
            }
        }

        //if not found, add a new class
        resultClasses.push(classToAdd);
    })
    
    //add the rest of the classes from search result if not already in resultClasses
    searchClasses.forEach(goodClass => {
        if (resultClasses.some(c => c.classNumber === goodClass.classNumber)) {
            return;
        }

        resultClasses.push(goodClass);
    })

    //populate the missing goods from the result search
    resultClasses.forEach(goodClass => {
        const goodClassFromSearch = searchClasses.find(item => item.classNumber === goodClass.classNumber);
        if (goodClassFromSearch) {
            goodClass.suggestions.push(...goodClassFromSearch.suggestions);
            //make the suggestions unique
            goodClass.suggestions = dedupeGoodsByExternalId(goodClass.suggestions);
        }
    })

    //populate the missing goods from the selected goods
    resultClasses.forEach(goodClass => {
        if (selectedClasses.some(classNumber =>classNumber === goodClass.classNumber)) {
            const goodsToAdd = selectedGoods.filter(good => good.classNumber === goodClass.classNumber);
            goodsToAdd.forEach(good => {
                if (goodClass.suggestions.find(suggestion => suggestion.externalId === good.externalId) === undefined) {
                    goodClass.suggestions.push(good);
                    //make the suggestions unique
                    goodClass.suggestions = dedupeGoodsByExternalId(goodClass.suggestions);
                }
            })
        }
    })

    // Replace class names 
    resultClasses.forEach(goodClass => {
        goodClass.name = `Class ${goodClass.classNumber}`;

        const goodClassInfo = GOOD_CLASSES.find(c => c.number === goodClass.classNumber);
        if (goodClassInfo) {
            goodClass.name = `${goodClass.name} ${goodClassInfo.short_name}`;
        }
    })

    return resultClasses;
}